import React from 'react';
import {PhotoIcon} from '@heroicons/react/24/outline';

import EditorToolbox from '../../toolboxes/Editor.Toolbox';
import EditorContentImage from './Editor.Content.Image';

interface IEditorToolboxImageProps {}

const EditorToolboxImage = ({}: IEditorToolboxImageProps) => {
  return (
    <EditorToolbox icon={<PhotoIcon />} text="Image">
      <EditorContentImage />
    </EditorToolbox>
  );
};

export default React.memo(EditorToolboxImage);
